/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import logo from "../../assets/logo.png";
import "./Login.css";
import {
  Grid2 as Grid,
  CircularProgress,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import AlternateEmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import SendIcon from "@mui/icons-material/Send";
import CodeIcon from "@mui/icons-material/Password";
import HourglassDisabledIcon from "@mui/icons-material/HourglassDisabled";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty, validate } from "validate.js";
import {
  resetStateAuth,
  userLogin,
  resetPassword,
  forgotPassword,
} from "../../app/slices/authSlice";
import AppMessage from "../../components/AppMessage/AppMessage";

const Login = () => {
  const {
    data: dataLogin,
    status: statusLogin,
    error: errorLogin,
  } = useSelector(({ auth }) => auth.login);
  const {
    data: dataOtp,
    status: statusOtp,
    error: errorOtp,
  } = useSelector(({ auth }) => auth.otp);
  const {
    data: dataPassword,
    status: statusPassword,
    error: errorPassword,
  } = useSelector(({ auth }) => auth.password);

  const [activeForm, setActiveForm] = useState("login");
  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState([]);
  const [response, setResponse] = useState(null);

  const dispatch = useDispatch();
  const passwordFormat = {
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/,
    message:
      "^Password should be at least 8 characters long, contain an uppercase letter, a lowercase  letter and a special character",
  };

  const loginSchema = {
    email: {
      presence: { allowEmpty: false },
      email: true,
    },
    password: {
      presence: { allowEmpty: false },
    },
  };
  const sendEmailSchema = {
    email: {
      presence: { allowEmpty: false },
      email: true,
    },
  };
  const resetPasswordSchema = {
    code: {
      presence: { allowEmpty: false },
    },
    newPassword: {
      presence: { allowEmpty: false },
      format: passwordFormat,
    },
    confirmPassword: {
      presence: { allowEmpty: false },
      format: passwordFormat,
    },
  };

  //use effects
  useEffect(() => {
    dispatch(resetStateAuth());
    return () => {
      dispatch(resetStateAuth());
    };
  }, []);

  useEffect(() => {
    if (dataLogin) {
      setResponse({
        message: dataLogin,
        type: "success",
      });

      setTimeout(() => {
        window.location.replace("/");
      }, 2000);
    }
  }, [dataLogin]);

  useEffect(() => {
    if (errorLogin) {
      setResponse({
        message: errorLogin?.message || "An error occurred, login failed",
        type: "error",
      });
    }
  }, [errorLogin]);

  useEffect(() => {
    if (errorOtp) {
      setResponse({
        message: errorOtp?.message || "An error occurred",
        type: "error",
      });
    }
  }, [errorOtp]);

  useEffect(() => {
    if (errorPassword) {
      setResponse({
        message: errorPassword?.message || "An error occurred",
        type: "error",
      });
    }
  }, [errorPassword]);

  useEffect(() => {
    if (dataPassword) {
      setResponse({
        message: dataPassword,
        type: "success",
      });
      setTimeout(() => {
        dispatch(resetStateAuth());
        window.location.reload();
      }, 2000);
    }
  }, [dataPassword]);

  useEffect(() => {
    if (dataOtp) {
      setResponse({
        message:
          "Enter the code sent to your email then create your new password",
        type: "info",
      });
    }
  }, [dataOtp]);

  //methods

  const changeFrom = () => {
    setFormValues({});
    setErrors([]);
    activeForm === "login"
      ? setActiveForm("forgotPassword")
      : setActiveForm("login");
  };

  //builders
  const handleSubmit = () => {
    if (activeForm === "login") {
      dispatch(resetStateAuth(["login"]));
      let _errors = validate(formValues, loginSchema);
      if (_errors) {
        setErrors(_errors);
        return;
      } else {
        setErrors([]);
      }

      dispatch(
        userLogin({
          email: formValues?.email?.toLowerCase(),
          password: formValues?.password,
        })
      );
    } else {
      //forgot password
      if (dataOtp == null) {
        //send email
        // dispatch(resetStateAuth(["otp"]));
        let _errors = validate(formValues, sendEmailSchema);
        if (_errors) {
          setErrors(_errors);
          return;
        } else {
          setErrors([]);
        }
        let _payload = {
          email: formValues?.email,
        };
        // alert(JSON.stringify(_payload));
        dispatch(forgotPassword(_payload));
      } else {
        //reset password
        // dispatch(resetStateAuth(["password"]));
        let _errors = validate(formValues, resetPasswordSchema);
        if (_errors) {
          setErrors(_errors);
          return;
        } else if (formValues?.newPassword !== formValues?.confirmPassword) {
          setErrors({
            newPassword: ["These two password don't match"],
            confirmPassword: ["These new passwords don't match"],
          });
          return;
        } else {
          setErrors([]);
        }

        let _payload = {
          email: formValues?.email,
          password: formValues?.newPassword,
          otp: formValues?.code,
        };
        // alert(JSON.stringify(_payload));
        dispatch(resetPassword(_payload));
      }
    }
  };

  const handleChange = (e) => {
    let inputName = e?.target?.name;
    let inputValue = e?.target?.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue,
    });
  };

  const BuildLoginForm = () => {
    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            required
            variant="outlined"
            name="email"
            type="email"
            id="email"
            onChange={handleChange}
            value={formValues?.email}
            label="Email"
            error={errors["email"] ? true : false}
            helperText={errors["email"] ? errors.email[0] : null}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <AlternateEmailIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            required
            variant="outlined"
            type="password"
            name="password"
            id="password"
            onChange={handleChange}
            value={formValues?.password}
            label="Password"
            error={errors["password"] ? true : false}
            helperText={errors["password"] ? errors.password[0] : null}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
        {BuildButton()}
        <Grid size={12}>
          <ul>
            <li>
              <a href="#" alt="Forgot password" onClick={changeFrom}>
                <HourglassDisabledIcon /> Forgot password
              </a>
            </li>
          </ul>
        </Grid>
      </Grid>
    );
  };

  const BuildForgotPasswordForm = () => {
    return (
      <Grid container spacing={2}>
        {dataOtp === null && (
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              required
              variant="outlined"
              name="email"
              type="email"
              value={formValues?.email}
              onChange={handleChange}
              id="emailAddress"
              label="Email Address"
              error={errors["email"] ? true : false}
              helperText={errors["email"] ? errors.email[0] : null}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <AlternateEmailIcon />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Grid>
        )}
        {dataOtp !== null && (
          <>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                required
                variant="outlined"
                name="code"
                type="text"
                value={formValues?.code}
                onChange={handleChange}
                id="code"
                label="Code"
                error={errors["code"] ? true : false}
                helperText={errors["code"] ? errors.code[0] : null}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <CodeIcon />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                required
                variant="outlined"
                name="newPassword"
                type="password"
                value={formValues?.newPassword}
                onChange={handleChange}
                id="new-password"
                label="New Password"
                error={errors["newPassword"] ? true : false}
                helperText={
                  errors["newPassword"] ? errors.newPassword[0] : null
                }
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                required
                variant="outlined"
                name="confirmPassword"
                type="password"
                value={formValues?.confirmPassword}
                onChange={handleChange}
                id="confirm-password"
                label="Confirm Password"
                error={errors["confirmPassword"] ? true : false}
                helperText={
                  errors["confirmPassword"] ? errors.confirmPassword[0] : null
                }
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Grid>
          </>
        )}
        {BuildButton()}
        <Grid size={12}>
          <ul>
            <li>
              <a href="#" alt="I have Account" onClick={changeFrom}>
                <HourglassDisabledIcon /> Go back to login
              </a>
            </li>
          </ul>
        </Grid>
      </Grid>
    );
  };

  const BuildButton = () => {
    return (
      <Grid size={12}>
        <div className="flex-row justify-content-center">
          <Button
            onClick={handleSubmit}
            fullWidth
            disabled={
              statusLogin === "loading" ||
              statusOtp === "loading" ||
              statusPassword === "loading" ||
              dataLogin ||
              dataPassword
            }
            variant="contained"
            size="large"
            endIcon={<SendIcon />}
          >
            {(statusLogin === "loading" ||
              statusOtp === "loading" ||
              statusPassword === "login") && (
              <CircularProgress
                size={20}
                color="white"
                style={{ marginRight: "5px" }}
              />
            )}
            {activeForm === "login" ? "LOGIN" : "SUBMIT"}
          </Button>
        </div>
      </Grid>
    );
  };

  return (
    <Grid container className="login">
      <Grid className="login-left" size={{ sm: 12, md: 8 }}>
        <img src={logo} alt="BOT" />
        <h1>
          Tanzania Financial Computer Emergency Response Team (TZ-FinCERT)
        </h1>
        {/* <p className="text-align-center">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec cursus
          dui non sollicitudin feugiat. Nam eget ante velit.
        </p> */}
      </Grid>

      <Grid size={{ sm: 12, md: 4 }}>
        <div className="login-form">
          <Grid container className="loginHeader">
            <Grid size={12} className="loginMainIcon">
              <AccountCircleIcon />
            </Grid>
            <Grid size={12}>
              {activeForm === "login" ? "Login" : "Forgot Password"}
            </Grid>
          </Grid>
          <div className="mt-30 mb-30">
            {response && (
              <AppMessage
                isOpen={response !== null}
                message={response?.message}
                messageType={response?.type}
                onClose={() => {
                  setResponse(null);
                }}
              />
            )}
          </div>
          {activeForm === "login" && BuildLoginForm()}
          {activeForm === "forgotPassword" && BuildForgotPasswordForm()}
        </div>
      </Grid>
    </Grid>
  );
};

export default Login;
